import { useEffect, useRef } from 'react';
import './askWorkspace.css';

// One viewport-bounded dialog; only its conversation area scrolls.
export default function AskOverlayDialog({ children, onClose }) {
  const panel = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const focusables = () => Array.from(panel.current?.querySelectorAll('button:not(:disabled), textarea:not(:disabled), input:not(:disabled), select:not(:disabled), a[href], [tabindex="0"]') || []).filter(el => !el.hidden && el.getAttribute('aria-hidden') !== 'true');
    (panel.current?.querySelector('textarea') || panel.current)?.focus();
    const keydown = event => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close.current(); }
      if (event.key !== 'Tab') return;
      const items = focusables();
      if (!items.length) { event.preventDefault(); panel.current?.focus(); return; }
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !panel.current?.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !panel.current?.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', keydown, true);
    return () => {
      document.removeEventListener('keydown', keydown, true);
      document.body.style.overflow = overflow;
      if (previous?.isConnected) previous.focus();
    };
  }, []);
  return <div className="ask-dialog-backdrop" data-testid="ask-overlay-backdrop" onClick={onClose}>
    <div ref={panel} className="ask-dialog-panel" data-testid="ask-overlay-panel" role="dialog" aria-modal="true" aria-label="Ask BioDataStudio" tabIndex={-1} onClick={event => event.stopPropagation()}>{children}</div>
  </div>;
}
